import { z } from 'zod';
import { priceSchema } from '../../validation';

/**
 * Optional bilateral overrides on top of `Client.settings.allow_auto_invoice_capture`
 * and `Org.settings.allow_auto_invoice_capture`. When set on the
 * Account doc, takes precedence over both party-level defaults.
 *
 * See `B5` of the org-to-org-invoice-refactor plan for the full
 * resolution order: `Account.settings` > `Agreement.terms.payment.invoiceIssuance`
 * > `Client.settings` > `Org.settings` > default(false).
 */
export const accountSettingsSchema = z
  .object({
    /**
     * If true, the carrier-leg of a delivered order auto-captures into
     * a leg invoice on this account. If false (or unset and no other
     * source overrides), the leg lands in the "eligible orders" queue
     * for manual capture.
     */
    allow_auto_invoice_capture: z.boolean().optional(),
    /**
     * Optional credit ceiling for this trading pair, denominated in
     * the account's currency. Reserved for future enforcement; not
     * read by the capture flow yet.
     */
    credit_limit: priceSchema.optional(),
  })
  .optional();

export type AccountSettings = z.infer<typeof accountSettingsSchema>;
